export default __webpack_public_path__ + "static/pacman-5b032e239cce4ad02d377a8cd287588c.png";